import { useEffect } from "react";

const DEFAULT_TITLE = "Alexander Efremidis · Cloud Engineer";
const DEFAULT_DESCRIPTION =
    "Persönliche Website von Alexander Efremidis, M. Sc. — Cloud Engineer mit Fokus auf On-Premise-Kubernetes, Plattform-Engineering und Automatisierung.";
const SITE_ORIGIN = "https://efremidis.de";

interface PageMeta {
    title: string;
    description?: string;
    path?: string;
}

export function usePageMeta({ title, description, path }: PageMeta) {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;

        const descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
        const ogTitleTag = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
        const ogDescriptionTag = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
        const ogUrlTag = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
        const twitterTitleTag = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
        const twitterDescriptionTag = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
        const canonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

        const previousDescription = descriptionTag?.content;
        const previousOgTitle = ogTitleTag?.content;
        const previousOgDescription = ogDescriptionTag?.content;
        const previousOgUrl = ogUrlTag?.content;
        const previousTwitterTitle = twitterTitleTag?.content;
        const previousTwitterDescription = twitterDescriptionTag?.content;
        const previousCanonical = canonicalTag?.href;

        const effectiveDescription = description ?? DEFAULT_DESCRIPTION;
        const effectiveUrl = path ? `${SITE_ORIGIN}${path}` : `${SITE_ORIGIN}/`;

        if (descriptionTag) descriptionTag.content = effectiveDescription;
        if (ogTitleTag) ogTitleTag.content = title;
        if (ogDescriptionTag) ogDescriptionTag.content = effectiveDescription;
        if (ogUrlTag) ogUrlTag.content = effectiveUrl;
        if (twitterTitleTag) twitterTitleTag.content = title;
        if (twitterDescriptionTag) twitterDescriptionTag.content = effectiveDescription;
        if (canonicalTag) canonicalTag.href = effectiveUrl;

        return () => {
            document.title = previousTitle;
            if (descriptionTag && previousDescription !== undefined) descriptionTag.content = previousDescription;
            if (ogTitleTag && previousOgTitle !== undefined) ogTitleTag.content = previousOgTitle;
            if (ogDescriptionTag && previousOgDescription !== undefined) ogDescriptionTag.content = previousOgDescription;
            if (ogUrlTag && previousOgUrl !== undefined) ogUrlTag.content = previousOgUrl;
            if (twitterTitleTag && previousTwitterTitle !== undefined) twitterTitleTag.content = previousTwitterTitle;
            if (twitterDescriptionTag && previousTwitterDescription !== undefined)
                twitterDescriptionTag.content = previousTwitterDescription;
            if (canonicalTag && previousCanonical !== undefined) canonicalTag.href = previousCanonical;
        };
    }, [title, description, path]);
}

export const defaults = {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
};
